import React, { useState } from 'react';
import { Volume2, VolumeX } from 'lucide-react';
import { isChimeMuted, getChimeVolume, setChimeMuted, setChimeVolume, playChime } from '@/lib/chime';

// Header control: click to mute/unmute in-app sounds; hover to reveal a volume
// slider. Preference is persisted.
export default function SoundToggle() {
  const [muted, setMutedState] = useState(isChimeMuted());
  const [volume, setVolumeState] = useState(getChimeVolume());
  const [open, setOpen] = useState(false);

  const toggleMute = () => {
    const next = !muted;
    setChimeMuted(next);
    setMutedState(next);
    if (!next) playChime();
  };

  const onVolume = (e) => {
    const v = parseFloat(e.target.value);
    setChimeVolume(v);
    setVolumeState(v);
    if (v > 0 && muted) { setChimeMuted(false); setMutedState(false); }
  };

  return (
    <div
      className="relative"
      onMouseEnter={() => setOpen(true)}
      onMouseLeave={() => setOpen(false)}
      data-testid="sound-control"
    >
      <button
        onClick={toggleMute}
        className="inline-flex items-center justify-center h-9 w-9 rounded-xl text-muted-foreground hover:text-foreground hover:bg-muted/50 transition-colors"
        title={muted ? 'Sounds muted — click to unmute' : 'Sounds on — click to mute'}
        aria-label={muted ? 'Sounds muted — click to unmute' : 'Sounds on — click to mute'}
        data-testid="sound-toggle-btn"
      >
        {muted || volume === 0 ? <VolumeX className="w-4 h-4" /> : <Volume2 className="w-4 h-4" />}
      </button>
      {open && (
        <div
          className="absolute right-0 top-full mt-1 z-[70] rounded-xl border border-border/50 p-3 shadow-xl"
          style={{ background: 'var(--glass-bg)', backdropFilter: 'blur(12px)' }}
          data-testid="sound-volume-popover"
        >
          <div className="flex items-center gap-2 w-40">
            <VolumeX className="w-3.5 h-3.5 text-muted-foreground" />
            <input
              type="range" min="0" max="1" step="0.05"
              value={muted ? 0 : volume}
              onChange={onVolume}
              className="flex-1 accent-primary cursor-pointer"
              data-testid="sound-volume-slider"
            />
            <Volume2 className="w-3.5 h-3.5 text-muted-foreground" />
          </div>
          <p className="text-[10px] text-muted-foreground mt-1 text-center">{muted ? 'Muted' : `${Math.round(volume * 100)}%`}</p>
        </div>
      )}
    </div>
  );
}
